import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { NgForm, NgModel } from '@angular/forms'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'
import { StorageService } from 'src/app/services/storage.service'
import Swal from 'sweetalert2'
import { TipoAplicacaoService } from 'src/app/services/tipo-aplicacao.service'
import { TipoAplicacao } from 'src/app/classes/TipoAplicacao'
import { TipoBico } from 'src/app/classes/TipoBico'

@Component({
  selector: 'app-forms-tipo-aplicacao',
  templateUrl: './forms-tipo-aplicacao.component.html',
  styleUrls: ['./forms-tipo-aplicacao.component.scss']
})
export class FormsTipoAplicacaoComponent implements OnInit {

  @ViewChild('Modal', { static: false }) modal: UiModalComponent
  @ViewChild('formulario', { static: false }) formulario!: NgForm
  @Output() finalizarSave: EventEmitter<void> = new EventEmitter()
  @Input() tiposBicos: TipoBico[] = []

  isSubmit: boolean = false
  tipoAplicacao: TipoAplicacao = new TipoAplicacao()
  carregando: boolean = false
  int32MaxValue = 2147483647

  constructor(
    private utils: UtilsService,
    private tipoAplicacaoService: TipoAplicacaoService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {}

  abrirModal(tipoAplicacao: TipoAplicacao = null): void {
    console.debug('tipoAplicacao', tipoAplicacao)
    if(tipoAplicacao == null && !this.utils.verificarPermissaoUsuario('incluirTipoAplicacao'))
      return
    if (tipoAplicacao != null){
      this.tipoAplicacao = tipoAplicacao
    }
    else
      this.tipoAplicacao = new TipoAplicacao()

    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
    this.formulario.resetForm()
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
    )
  }

  save(): void {
    console.debug(this.tipoAplicacao)
    this.carregando = true

    if (!this.validarForm()) return

    this.tipoAplicacao.UsuarioAlteracao = null;
    this.tipoAplicacao.UsuarioCadastro = null;
    if (this.tipoAplicacao.Id) {
      this.tipoAplicacaoService
        .putTipoAplicacao(this.tipoAplicacao.Id, this.tipoAplicacao)
        .subscribe(
          (res) => {
            this.finalizarSaveRequestSuccess(
              'Tipo de Aplicação alterado com sucesso!',
            )
          },
          (err) => {
            this.finalizarRequestError(err)
          },
        )
    } else {
      this.tipoAplicacaoService.postTipoAplicacao(this.tipoAplicacao).subscribe(
        (res) => {
          this.finalizarSaveRequestSuccess(
            'Tipo de Aplicação cadastrado com sucesso!',
          )
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

  confirmExcluirTipoAplicacao(tipoAplicacao: TipoAplicacao): void{
    if(!this.utils.verificarPermissaoUsuario('ExcluirTipoAplicacao'))
      return
    Swal.fire({
      title: 'Você tem certeza desta ação?',
      text:
        'Deseja excluir este Tipo de Aplicação? Essa ação é irreversível!',
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Excluir Tipo de Aplicação',
    }).then((response) => {
      if (!response.dismiss) {
        this.excluir(tipoAplicacao)
      }
    })
  }

  excluir(tipoAplicacao: TipoAplicacao): void{
    this.carregando = true

    this.tipoAplicacaoService.deleteTipoAplicacao(tipoAplicacao.Id).subscribe(
      res => {
        this.utils.handleSuccess("Tipo de Aplicação excluído com sucesso!")
        this.carregando = false
        this.finalizarSave.emit()
        this.fecharModal()
      },
      err => {
        this.utils.getErro(err)
        this.carregando = false
      }
    )
  }

  validarForm(): boolean {
    if (this.formulario.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit()
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
  }
}


